export const QUIZ_QUESTION_FEATURE_KEY = 'quiz-question';
